import React from "react";
import ExpandDiv from "../common/ExpandDiv";
import FormsyLink from "./FormsyLink";
import DocusignForm from "./DocusignForm";
import LinkForm from "../common/LinkForm";
import CaseyLifeSkills from "../assessments/CaseyLifeSkills";
import { sendEmail } from "../services/soar";

function FormsList({ clientProgram, contactID, addToDocusignList, formsInfo }) {
  const programConfig = clientProgram["unit.sor_safyportalconfig"]
    ? JSON.parse(clientProgram["unit.sor_safyportalconfig"])
    : null;

  const formsToShow = programConfig.forms || [];

  const getForm = (formName) => {
    let formObject = {};
    let f = formsInfo.find(
      (form) => form.FormName.toLowerCase() === formName.toLowerCase()
    );
    if (f) {
      const version = f.Versions.find((v) => {
        if (!v.Active) return false;

        if (
          v.InDevelopment &&
          process.env.REACT_APP_ENVIRONMENT !== "Development"
        )
          return false;

        return true;
      });

      if (!version) {
        return {};
      }

      const setupConfiguration = version
        ? JSON.parse(version.SetupConfiguration)
        : {};

      formObject = {
        formId: f.FormId,
        formName:
          setupConfiguration.type === "Formsy"
            ? setupConfiguration.portalFormName
            : setupConfiguration.type === "Docusign"
            ? setupConfiguration.form[0].FormDescription
            : f.FormDescription,
        formDescription: f.FormDescription,
        formPath: setupConfiguration.formPath,
        formVersionId: version.VersionId,
        formVersionNumber: version.VersionIntId.toString(),
        reportFieldNames: setupConfiguration.reportFieldNames,
        formType: setupConfiguration.type,
        setupConfiguration: setupConfiguration,
        formData: f,
      };
      if (setupConfiguration.extraFields) {
        formObject.extraFields = setupConfiguration.extraFields;
      }
      if (setupConfiguration.reportFieldNames) {
        formObject.reportFieldNames = setupConfiguration.reportFieldNames;
      }
    } else {
      if (formName.includes("v")) {
        var regex = /[v]\d/;
        let match = regex.exec(formName.toLowerCase());
        //console.log("Checking Form Version and RegEx Match", formName, match);
        if (match?.index) {
          const coreForm = formName.toLowerCase().substring(0, match.index);
          f = formsInfo.find(
            (form) => form.FormName.toLowerCase() === coreForm
          );
          if (f) {
            const specificVersion = f.Versions.find(
              (v) =>
                v.VersionIntId.toString() ===
                formName.toLowerCase().substring(match.index + 1)
            );
            const specificSetupConfiguration = JSON.parse(
              specificVersion.SetupConfiguration
            );
            formObject = {
              formId: f.FormId,
              formName: specificSetupConfiguration.portalFormName,
              formDescription: specificSetupConfiguration.formDescription,
              formPath: specificSetupConfiguration.formPath,
              formVersionId: specificVersion.VersionId,
              formVersionNumber: specificVersion.VersionIntId.toString(),
              formType: specificSetupConfiguration.type,
              setupConfiguration: specificSetupConfiguration,
              formData: f,
            };
            if (specificSetupConfiguration.extraFields) {
              formObject.extraFields = specificSetupConfiguration.extraFields;
            }
            if (specificSetupConfiguration.reportFieldNames) {
              formObject.reportFieldNames =
                specificSetupConfiguration.reportFieldNames;
            }
          } else {
            console.log("Form or Form Version not found", formName);
            return {};
          }
        }
      } else {
        console.log("Form not found", formName);
        return {};
      }
    }
    return formObject;
  };

  return (
    <div className="mb-4">
      <div className="border p-2 bg-light">
        <div className="h5">Add New Forms</div>
        {formsInfo.length > 0 &&
          formsToShow &&
          formsToShow.map((section, formstoshowindex) => (
            <div key={`formsection${formstoshowindex}`}>
              {Array.isArray(section[Object.keys(section)]) && (
                <ExpandDiv
                  key={`section${formstoshowindex}`}
                  title={Object.keys(section)}
                  className="ms-4"
                >
                  <>
                    {section[Object.keys(section)].map((form) => {
                      //const formLink = getFormList(form, docusignForms);
                      const formLink = getForm(form);

                      if (!formLink) {
                        return null;
                        //add logic to track/notify
                      }

                      if (formLink.formType === "Formsy") {
                        return (
                          <FormsyLink
                            key={`formsy${formLink.formName}`}
                            contactID={contactID}
                            clientProgram={clientProgram}
                            formName={formLink.formName}
                            formVersionNumber={formLink.formVersionNumber}
                            formVersionId={formLink.formVersionId} // TODO: change with new formsy database
                            formPath={formLink.formPath}
                            tab="forms"
                            extraFields={formLink.extraFields}
                          ></FormsyLink>
                        );
                      } else if (formLink.formType === "Docusign") {
                        //Check for Docusign Test
                        return (
                          <DocusignForm
                            key={`dsform${form}`}
                            form={formLink.setupConfiguration.form[0]}
                            addToDocusignList={addToDocusignList}
                          ></DocusignForm>
                        );
                      } else if (formLink.setupConfiguration?.url) {
                        return (
                          <LinkForm
                            key={`linkform${formLink.setupConfiguration.name}`}
                            name={formLink.setupConfiguration.name}
                            url={formLink.setupConfiguration.url}
                          ></LinkForm>
                        );
                      } else if (formLink?.multiurl) {
                        return formLink.multiurl.map((link) => {
                          return (
                            <LinkForm
                              key={`multilink${link.name}`}
                              name={link.name}
                              url={link.url}
                            ></LinkForm>
                          );
                        });
                      } else if (formLink.setupConfiguration?.CaseyLifeSkills) {
                        return (
                          <CaseyLifeSkills
                            key={`casey${form}`}
                            className="p-2 m-2"
                            contactID={contactID}
                          ></CaseyLifeSkills>
                        );
                      } else {
                        console.log("No Match", form, formLink);
                        sendEmail(
                          "hiebertc@safy.org",
                          "hiebertc@safy.org",
                          "Matching form not found",
                          `Matching PU form not found ${form} - ${
                            process.env.REACT_APP_ENVIRONMENT
                          } - ${JSON.stringify(formLink)}`
                        );
                        return null;
                      }
                    })}
                  </>
                </ExpandDiv>
              )}
            </div>
          ))}
      </div>
    </div>
  );
}

export default FormsList;
